import { render, staticRenderFns } from "./ServiceInfoSave.vue?vue&type=template&id=ef6ae05a&"
import script from "./ServiceInfoSave.vue?vue&type=script&lang=js&"
export * from "./ServiceInfoSave.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/pages/pages.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports